"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var TextField_1 = require("atomicComponents/atoms/Forms/TextField");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var TableTextField = (0, material_1.styled)(TextField_1.FieldRenderTextField)(function (_a) {
    var _b, _c;
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    return ({
        width: '100%',
        input: {
            '::placeholder': {
                color: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main,
                opacity: 1, /* Firefox */
            },
        },
        fieldset: {
            borderColor: (props === null || props === void 0 ? void 0 : props.color) && ((_c = theme.palette[props.color || 'primary']) === null || _c === void 0 ? void 0 : _c.light),
        },
        '.Mui-disabled': {
            opacity: 0.5,
        },
        '.MuiOutlinedInput-root': {
            '&.MuiInputBase-sizeSmall': {
                input: { padding: theme.spacing(0.5625, 1.5) },
            },
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(TableTextField, { size: 'small', showLabel: false });
